/* eslint-disable */
// Business-siden: dansk (da) er standard og redigeres i CMS'et. Engelsk er en bundlet oversættelse.
// Business 2.0 kører på da + en. Øvrige sprog genbesøges, når indholdet er fuldt oversat.

export const LANGUAGES = [
  { code: "da", label: "Dansk", flag: "🇩🇰", rtl: false },
  { code: "en", label: "English", flag: "🇬🇧", rtl: false },
];

export const TRANSLATIONS = {
  en: {
    promo: "We take over bookkeeping, payroll, invoicing and the administration of your vehicles, you keep the road.",
    hero: {
      badge: "Votra Business · Managed operations for transport",
      titleStart: "We run the business",
      titleAccent: "behind your haulage business",
      subtitle:
        "Votra Business is your external operations and finance department. We do the bookkeeping, send the invoices, chase your debtors, run payroll, keep track of what each vehicle costs and when your drivers' documents expire, and you see it all in your own portal with one named adviser at the other end.",
      primaryCta: "Book an operations review",
      secondaryCta: "See what we take over",
    },
    finalCta: {
      title: "You should never have to assemble your own business out of five different suppliers.",
      button: "Book an operations review",
    },
    form: {
      sectionLabel: "Contact",
      sectionTitle: "Book an operations review",
      sectionSubtitle:
        "We go through your business and come back with a concrete proposal: what we take over, what it requires from you, and what it costs. No obligation.",
      submitButton: "Book an operations review",
      helperText: "We reply within one working day. No obligations.",
      successTitle: "Thank you for your enquiry!",
      successText: "We will get back to you within one working day by phone or email.",
      labels: { name: "Name", company: "Company", phone: "Phone", email: "Email", trucks: "Number of vehicles", message: "What are you handling yourself today?" },
    },
    footer: { tagline: "Managed operations for hauliers" },
    testimonials: {
      sectionLabel: "Client voices",
      sectionTitle: "What our clients say",
      sectionSubtitle: "We only publish statements we have received from a named client who has approved the wording.",
      items: [],
    },
    chat: { open: "Chat with us", title: "Votra Business", online: "We are online", offline: "Write, we'll get back to you" },
  },
};
